module.exports = __webpack_public_path__ + "static/media/pink-marker.71e1bce1.svg";